

















































































import {
  defineComponent, reactive, toRefs, watch,
} from '@vue/composition-api'

import ModalDialog from '@/components/appBase/ModalDialog.vue'
import ApiError from '@/components/appBase/errors/ApiError.vue'
// import DelayedDisplay from '@/components/appBase/DelayedDisplay.vue'
import useApiErrorViewHandler from '@/components/appBase/errors/useApiErrorViewHandler'
import useClientflowApi from '@/api/clientFlow/useClientflowApi'

const initialState: {
  showMe: boolean;
  confirmChecked: boolean;
  formIsValid: boolean;
} = {
  showMe: true,
  confirmChecked: false,
  formIsValid: false,
}

export default defineComponent({
  name: 'DeleteClientModal',
  components: {
    ModalDialog, ApiError,
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
    clientId: {
      type: String,
      default: '',
      required: true,
    },
    clientName: {
      type: String,
      default: '',
      required: true,
    },

  },

  setup(props, { emit }) {
    const state = reactive({ ...initialState })

    function confirm(): void {
      emit('confirmed')
    }
    function cancel(): void {
      emit('cancelled')
    }

    watch(
      () => props.show,
      (show) => {
        state.showMe = show
      },
    )

    watch(
      () => state.showMe,
      (show) => {
        if (!show) emit('cancelled')
      },
    )

    // Compose!
    // ...delegate api handling to useClientflowApi():
    const {
      ClientFlowApi,
      awaitingResponse,
      hasResponseError,
      handler,
      errorDisplay,
    } = useClientflowApi()

    // ...delegate logic around showing api error to useApiErrorViewHandler():
    const {
      errorVisibilityHasChangedTo,
      toggleShowApiError,
      showResponseError,
      showingResponseError,
    } = useApiErrorViewHandler(hasResponseError)

    async function deleteClient(clientId: string) {
      const cmd = await ClientFlowApi.deleteClient({
        clientId,
      })
      const response = await handler.handle(cmd)
      if (response.isOk()) {
        emit('client-deleted')
      }
    }

    return {
      ...toRefs(state),
      confirm,
      cancel,
      deleteClient,

      // from use ClienFlowApi
      hasResponseError,
      awaitingResponse,
      errorDisplay,

      // from useApiErrorViewHandler
      showingResponseError,
      showResponseError,
      toggleShowApiError,
      errorVisibilityHasChangedTo,
    }
  },

})

